import {FoodItem} from "../../types";

export const getFoodById = (menu: FoodItem[], fid: number) => {
    return menu ? menu.find((item: FoodItem) => item.id === fid) : undefined;
};

export const hideCart = (dispatch: any) => {
    dispatch({
        type: "TOGGLE_CART",
        showCart: !true,
    });
};

export const fetchCookies = async (dispatch: any) => {
    if (localStorage.getItem("CartItems")) {
        const cookiesAccept = Boolean(localStorage.getItem("CookiesAccept"))
        console.log(cookiesAccept)
        dispatch({
            type: "SET_COOKIE_ACCEPT",
            cookieAccept: cookiesAccept,
        });
    }
};
